import { Modal, Tree, Button, message } from "antd";
import axios from "axios";
import { useState } from "react";

import { showErrorNotification } from "../../../../../utils/notification";

const BlogMoveModal = ({ config, onClose, ROOT_URL, BASE_URL, treeData }) => {
  const [selectedFolderKey, setSelectedFolderKey] = useState(null);
  const [moving, setMoving] = useState(false);

  const buildFolderTree = (nodes) =>
    nodes
      .filter((node) => node.isFolder)
      .map((node) => ({
        title: node.title,
        key: node.activeUniqueUrlIdentifier,
        children: buildFolderTree(node.children || [])
      }));

  const handleMove = async () => {
    if (!selectedFolderKey) {
      message.warning("Select a target folder first");
      return;
    }

    if (selectedFolderKey === config.parentNode?.activeUniqueUrlIdentifier) {
      message.warning("Blog is already in this folder");
      return;
    }

    setMoving(true);
    try {
      await axios.post(`${ROOT_URL}/${BASE_URL}/tree-node/move`, {
        activeUniqueUrlIdentifier: config.parentNode.activeUniqueUrlIdentifier,
        folderActiveUniqueUrlIdentifier: selectedFolderKey
      });
      message.success("Blog moved successfully");
      onClose(true);
    } catch (err) {
      showErrorNotification(err);
    } finally {
      setMoving(false);
    }
  };

  return (
    <Modal
      open={config.open}
      title={`Move Blog: ${config.parentNode?.title}`}
      onCancel={() => onClose(false)}
      footer={[
        <Button key="cancel" onClick={() => onClose(false)}>
          Cancel
        </Button>,
        <Button key="move" type="primary" loading={moving} onClick={handleMove}>
          Move
        </Button>
      ]}
    >
      <Tree
        treeData={buildFolderTree(treeData)}
        selectable
        defaultExpandAll
        onSelect={(keys) => setSelectedFolderKey(keys[0])}
      />
    </Modal>
  );
};

export default BlogMoveModal;
